/**
 * Movement Type Master — Spring Boot API.
 */
import type { CreateMovementTypeInput, MovementType } from '../../shared/types/movement';
import { api } from './http';

export const movementTypeMockApi = {
  getAll: async (filters?: {
    category?: string;
    direction?: string;
    activeOnly?: boolean;
  }) => {
    const res = await api<MovementType[]>('/api/inventory/movement-types');
    if (!res.success || !res.data) return res;
    let list = res.data;
    if (filters?.category && filters.category !== 'all') {
      list = list.filter((r) => r.category === filters.category);
    }
    if (filters?.direction && filters.direction !== 'all') {
      list = list.filter((r) => r.direction === filters.direction);
    }
    if (filters?.activeOnly) list = list.filter((r) => r.is_active);
    return { success: true as const, data: list };
  },

  getByCode: async (code: string) => {
    const res = await api<MovementType[]>('/api/inventory/movement-types');
    if (!res.success || !res.data) return res;
    const row = res.data.find((r) => r.movement_code === code);
    return row
      ? { success: true as const, data: row }
      : { success: false as const, error: 'Movement type not found' };
  },

  create: async (input: CreateMovementTypeInput) =>
    api('/api/inventory/movement-types', { method: 'POST', body: JSON.stringify(input) }),

  update: async (id: string, input: Partial<CreateMovementTypeInput>) =>
    api(`/api/inventory/movement-types/${id}`, { method: 'PUT', body: JSON.stringify(input) }),

  deactivate: async (id: string) =>
    api(`/api/inventory/movement-types/${id}/deactivate`, { method: 'POST' }),
};
